module.exports = __webpack_public_path__ + "static/media/Express1.1d75c3f5.png";